/** 历史推断仅作为原始数据详情，不凭字段名猜测科研语义。 */
export function reportReadingSections(document) {
    if (document.report?.sections.length)
        return document.report.sections;
    const findings = [], details = [], files = [];
    document.blocks.forEach((block, index) => {
        if (block.kind === "markdown" || ("derivation" in block && block.derivation === "declared"))
            findings.push(index);
        else if (block.kind === "artifacts")
            files.push(index);
        else
            details.push(index);
    });
    return [
        {
            sectionId: "summary",
            title: "结论与结果",
            role: "finding",
            layout: "stack",
            blockIndices: findings,
            captions: [],
        },
        {
            sectionId: "files",
            title: "结果文件",
            role: "appendix",
            layout: "stack",
            blockIndices: files,
            captions: [],
        },
        {
            sectionId: "details",
            title: "原始结果与运行记录",
            role: "appendix",
            layout: "stack",
            blockIndices: details,
            captions: [],
        },
    ].filter((section) => section.blockIndices.length > 0);
}
export function reportBlockIsRaw(block, document) {
    return (!document.report &&
        (block.kind === "metrics" ||
            block.kind === "table" ||
            block.kind === "chart" ||
            block.kind === "sequence" ||
            block.kind === "matrix") &&
        block.derivation !== "declared");
}
export function reportTime(value) {
    return (new Intl.DateTimeFormat("zh-CN", {
        timeZone: "Asia/Shanghai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).format(new Date(value)) + " UTC+08:00");
}
//# sourceMappingURL=report-reading.js.map